export interface Patch<T> {
  id: string | number;
  changes: Partial<T>;
}
